import React from 'react';

import { styled } from '@mui/material';
import PropTypes from 'prop-types';

import TextCellSkeleton from 'components/SkeletonScreen/components/TextCellSkeleton';
import { TypographyEllipsis } from 'components/Templates/TypographyEllipsis';
import Tile from 'components/Tile/Tile';

const Div_Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  overflow: 'hidden',
}));

const Div_TextsWrapper = styled('div')({
  flex: 1,
  minWidth: 0,
});

const Div_TextAndIcon = styled('div')(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const Div_BottomLineWrapper = styled('div')(
  ({ theme, hasTwoElements }) =>
    hasTwoElements
      ? {
          marginTop: theme.spacing(0.5),
          lineHeight: '0.875rem',
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(2),
        }
      : { marginTop: theme.spacing(0.5), lineHeight: '0.875rem' },
);

const TextCell = ({
  icon,
  mainText,
  mainTextVariant = 'subtitle',
  mainTextIcon,
  description,
  loading,
  tile,
  tileColor,
  customStyles,
}) => {
  if (loading) return <TextCellSkeleton hasDescription={!!description} />;
  const mainTextComponent = (
    <TypographyEllipsis noWrap component="p" variant={mainTextVariant}>
      {mainText || '-'}
    </TypographyEllipsis>
  );
  return (
    <Div_Wrapper style={customStyles}>
      {icon && mainText ? icon : null}
      <Div_TextsWrapper>
        {mainText && mainTextIcon ? (
          <Div_TextAndIcon>
            {mainTextComponent}
            {mainTextIcon}
          </Div_TextAndIcon>
        ) : (
          mainTextComponent
        )}
        {(description || tile) && (
          <Div_BottomLineWrapper hasTwoElements={description && tile}>
            {description && (
              <TypographyEllipsis noWrap component="span" variant="subtitleLight">
                {description}
              </TypographyEllipsis>
            )}
            {tile && <Tile color={tileColor} label={tile} />}
          </Div_BottomLineWrapper>
        )}
      </Div_TextsWrapper>
    </Div_Wrapper>
  );
};

TextCell.propTypes = {
  mainText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mainTextIcon: PropTypes.node,
  mainTextVariant: PropTypes.oneOf(['subtitle', 'subtitleLight', 'subtitleBold']),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.node,
  loading: PropTypes.bool,
  tile: PropTypes.string,
  tileColor: PropTypes.oneOf(['draft', 'info', 'success', 'warning', 'error']),
  customStyles: PropTypes.object,
};

export default TextCell;
